<template>
  <div class="row">

    <!-- Date -->
    <div class="col-md-6">
      <datepicker
        v-model="fields.date"
        :max-date="maxDate"
        name="contact_date"
        input-class-name="form-control-sm">
      </datepicker>
    </div>

    <!-- Type -->
    <div class="col-md-6">
      <select name="contact_type" v-model="fields.type" class="form-control form-control-sm">
        <option v-for="type in contactTypes" :value="type">{{ type[0].toUpperCase() + type.slice(1) }}</option>
      </select>
    </div>

  </div>
  <div v-if="fields.date" class="row mt-1">

    <!-- Person -->
    <div class="col-md-6">
      <input name="contact_person" v-model="fields.person" class="form-control form-control-sm" placeholder="Contact person">
    </div>

    <!-- Method -->
    <div class="col-md-6">
      <select name="contact_method" v-model="fields.method" class="form-control form-control-sm">
        <option value="">Contact method...</option>
        <option v-for="(method, id) in contactMethods" :value="id">{{ method }}</option>
      </select>
    </div>

  </div>
  <div v-if="fields.date" class="row mt-1">

    <!-- Comments -->
    <div class="col-md-12">
      <textarea name="contact_comments"  v-model="fields.comments" class="form-control form-control-sm" placeholder="Enter any comments related to the contact..." rows="3"></textarea>
    </div>

  </div>
</template>

<script>
export default {

  props: {
    contactTypes: {type: Array, required: true},
    contactMethods: {type: Object, required: true},
  },

  data() {
    return {
      fields: {
        date: '',
        type: 'adjuster',
        person: '',
        method: '',
        comments: '',
      },
    }
  },
  computed: {
    maxDate() {
      return moment(new Date()).set({hour: 23, minute: 59, second: 59, millisecond: 999}).format('MM/dd/yyyy');
    },
  }
}
</script>
